export const URGENCY_OFFER_COHORT_VAR3 = 'ref_urgency_offer_var3';

export const URGENCY_OFFER_COHORT_REWARD_AMOUNTS = {
  [URGENCY_OFFER_COHORT_VAR3]: 125,
};
